import * as Yup from 'yup';
import i18n from 'i18n';

const schema = Yup.object().shape({
  Nome: Yup.string().required(() => i18n.t('common:validation.fieldRequired')),
  EmailAlternativo: Yup.string()
    .email(() => i18n.t('common:validation.emailInvalid'))
    .nullable(),
  Telefone: Yup.string()
    .required(() => i18n.t('common:validation.fieldRequired'))
    .min(14, () => i18n.t('common:validation.invalidPhone'))
    .max(15, () => i18n.t('common:validation.invalidPhone')),
  Faculdade: Yup.string().nullable(),
});

export default schema;
